import axios from "axios";

/**
 * An axios instance that sends the Rails CSRF token (`X-CSRF-Token`) with every request.
 *
 * Controllers that inherit directly from `ActionController::Base` (e.g. the super user /
 * support controllers) are protected by `protect_from_forgery`, so non-GET requests made with
 * the plain axios default export are rejected with a 422 `ActionController::InvalidAuthenticityToken`.
 *
 * Use this instead of the default axios export for POST/PUT/PATCH/DELETE requests to those controllers.
 * It is intentionally only for same-origin Rails endpoints; don't use it for third-party URLs.
 */
const csrfAxios = axios.create();

csrfAxios.interceptors.request.use(
  (config) => {
    // eslint-disable-next-line no-param-reassign
    config.headers["X-CSRF-Token"] = window.ReactOnRails.authenticityToken();

    return config;
  },
  (error) => Promise.reject(error),
);

export default csrfAxios;
